import theme from "@/theme";

export interface MetricItem {
  id: string;
  title: string;
  value: string;
  status: string;
  showChevron?: boolean;
  lastUpdated?: string;
}

export enum WellnessScoreStatus {
  Healthy,
  NeedsAttention,
  NeedsSupport,
  Incomplete,
}

export interface WellnessCategoryCardProps {
  icon: React.ReactNode;
  title: string;
  status?: WellnessScoreStatus;
  description: string;
  lastUpdated?: string;
  children?: React.ReactNode;
}

export const status: Record<string, string> = {
  healthy: "healthy",
  needAttention: "needAttention",
  needsSupport: "needsSupport",
};

export const healthStatusColours: Record<string, string> = {
  healthy: theme.palette.accent1.main,
  needsAttention: theme.palette.secondary[700] as string,
  needsSupport: theme.palette.error.main,
};

export function getWellnessScoreStatusFromScore(
  score: number,
  completeness?: number
): WellnessScoreStatus {
  if (completeness != null && completeness < 100) {
    return WellnessScoreStatus.Incomplete;
  }
  if (score > 60) return WellnessScoreStatus.Healthy;
  if (score >= 20) return WellnessScoreStatus.NeedsAttention;
  return WellnessScoreStatus.NeedsSupport;
}
